(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("kI8SP", function(module, exports) {

$parcel$export(module.exports, "register", () => $f13ecebb1f16f955$export$6503ec6e8aabbaf, (v) => $f13ecebb1f16f955$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $f13ecebb1f16f955$export$f7ad0328861e2f03, (v) => $f13ecebb1f16f955$export$f7ad0328861e2f03 = v);
var $f13ecebb1f16f955$export$6503ec6e8aabbaf;
var $f13ecebb1f16f955$export$f7ad0328861e2f03;
"use strict";
var $f13ecebb1f16f955$var$mapping = new Map();
function $f13ecebb1f16f955$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$f13ecebb1f16f955$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $f13ecebb1f16f955$var$resolve(id) {
    var resolved = $f13ecebb1f16f955$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$f13ecebb1f16f955$export$6503ec6e8aabbaf = $f13ecebb1f16f955$var$register;
$f13ecebb1f16f955$export$f7ad0328861e2f03 = $f13ecebb1f16f955$var$resolve;

});

parcelRegister("hIarR", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", () => $ce4ea6902f7a0721$export$bdfd709ae4826697, (v) => $ce4ea6902f7a0721$export$bdfd709ae4826697 = v);
var $ce4ea6902f7a0721$export$bdfd709ae4826697;
var $ce4ea6902f7a0721$export$c9e73fbda7da57b6;
var $ce4ea6902f7a0721$export$5a759dc7a1cfb72a;
"use strict";
var $ce4ea6902f7a0721$var$bundleURL = {};
function $ce4ea6902f7a0721$var$getBundleURLCached(id) {
    var value = $ce4ea6902f7a0721$var$bundleURL[id];
    if (!value) {
        value = $ce4ea6902f7a0721$var$getBundleURL();
        $ce4ea6902f7a0721$var$bundleURL[id] = value;
    }
    return value;
}
function $ce4ea6902f7a0721$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ('' + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $ce4ea6902f7a0721$var$getBaseURL(matches[2]);
    }
    return '/';
}
function $ce4ea6902f7a0721$var$getBaseURL(url) {
    return ('' + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, '$1') + '/';
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $ce4ea6902f7a0721$var$getOrigin(url) {
    var matches = ('' + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error('Origin not found');
    return matches[0];
}
$ce4ea6902f7a0721$export$bdfd709ae4826697 = $ce4ea6902f7a0721$var$getBundleURLCached;
$ce4ea6902f7a0721$export$c9e73fbda7da57b6 = $ce4ea6902f7a0721$var$getBaseURL;
$ce4ea6902f7a0721$export$5a759dc7a1cfb72a = $ce4ea6902f7a0721$var$getOrigin;

});

parcelRegister("gWV8w", function(module, exports) {


module.exports = (parcelRequire("dNLwc"))((parcelRequire("kI8SP")).resolve("bEPRd")).then(()=>parcelRequire('8NFma'));

});
parcelRegister("dNLwc", function(module, exports) {
"use strict";

var $7lV8K = parcelRequire("7lV8K");
module.exports = $7lV8K(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName('script');
        if ([].concat(existingScripts).some(function(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement('link');
        preloadLink.href = bundle;
        preloadLink.rel = 'preload';
        preloadLink.as = 'script';
        document.head.appendChild(preloadLink);
        var script = document.createElement('script');
        script.async = true;
        script.type = 'text/javascript';
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(script);
    });
});

});
parcelRegister("7lV8K", function(module, exports) {
"use strict";
var $55a6d16921f8ab25$var$cachedBundles = {};
var $55a6d16921f8ab25$var$cachedPreloads = {};
var $55a6d16921f8ab25$var$cachedPrefetches = {};
function $55a6d16921f8ab25$var$getCache(type) {
    switch(type){
        case 'preload':
            return $55a6d16921f8ab25$var$cachedPreloads;
        case 'prefetch':
            return $55a6d16921f8ab25$var$cachedPrefetches;
        default:
            return $55a6d16921f8ab25$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $55a6d16921f8ab25$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("dFHx4", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("dNLwc"))((parcelRequire("kI8SP")).resolve("3VupZ")),
    (parcelRequire("dNLwc"))((parcelRequire("kI8SP")).resolve("bEPRd")),
    (parcelRequire("dNLwc"))((parcelRequire("kI8SP")).resolve("5ksUP"))
]).then(()=>parcelRequire('6T1J1'));

});

parcelRegister("V5CkR", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("dNLwc"))((parcelRequire("kI8SP")).resolve("bEPRd")),
    (parcelRequire("dNLwc"))((parcelRequire("kI8SP")).resolve("c7q2w"))
]).then(()=>parcelRequire('lGyDP'));

});

parcelRegister("fi5wH", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("dNLwc"))((parcelRequire("kI8SP")).resolve("bEPRd")),
    (parcelRequire("dNLwc"))((parcelRequire("kI8SP")).resolve("3VupZ"))
]).then(()=>parcelRequire('2pmb0'));

});

var $a60b9785bec4c33a$exports = {};


(parcelRequire("kI8SP")).register((parcelRequire("hIarR")).getBundleURL('4FGBW'), JSON.parse("[\"4FGBW\",\"main.js\",\"bEPRd\",\"react.0e7f2a42.js\",\"5ksUP\",\"client.ca81dd86.js\",\"3VupZ\",\"react-dom.e6efdc2c.js\",\"c7q2w\",\"AtunwaPlayer.4c04188e.js\",\"i5Qhj\",\"RootApp.2dfffdfa.js\",\"t99t9\",\"AtunwaPlayerMeta.845dc322.js\",\"1skPS\",\"AtunwaPlayerBundle.de47dafa.js\",\"DWwKV\",\"VerticalAdBanner.9275a730.js\",\"fKeJF\",\"VerticalAdBanner.77d2f701.css\",\"2AYWl\",\"RefreshableGptAd.2af04f3d.js\",\"gHYZV\",\"atunwa.f906881e.svg\",\"4wrnU\",\"MinimalAudioBar.494cbcbd.js\",\"iTOIn\",\"MinimalAudioBar.9a4ad4ab.css\",\"4uiZR\",\"ErrorBanner.f0eee3a7.js\",\"3EFGH\",\"ErrorBanner.aefa0566.css\",\"mEX82\",\"AtunwaPlayerBundle.8ccf3e0e.css\",\"iOpp6\",\"RootApp.2deb255f.css\"]"));

/* Auto-inject the built CSS when the UMD/ES bundle or embedded build is loaded in a browser.
 * This ensures the player looks correct when embedded as a web component
 * without requiring the host page to manually include the CSS file.
 *
 * The injector determines the bundle's directory from the current script tag
 * and appends a <link rel="stylesheet"> to the corresponding CSS file in the same dir.
 * - Library builds (dist): injects `atunwa-player.css`
 * - Embedded build (embedded): injects `main.css`
 */ (function injectAtunwaStyles() {
    if (typeof document === 'undefined') return;
    const MARKER_ID = 'atunwa-player-css';
    if (document.getElementById(MARKER_ID)) return; // already injected
    // Find the script tag that loaded the library (ES/UMD) or embedded build (main.js)
    // We try document.currentScript first, then fall back to a heuristic search.
    const current = document.currentScript;
    const candidates = [];
    if (current && current.src) candidates.push(current);
    candidates.push(...Array.from(document.querySelectorAll('script[src]')).filter((s)=>{
        const src = s.src || '';
        return /atunwa-player\.(?:umd|es)\.js($|\?)/.test(src) || /my-lib\.(?:umd|es)\.js($|\?)/.test(src) || /\/main\.js($|\?)/.test(src);
    }));
    let cssHref = null;
    for (const script of candidates)try {
        const url = new URL(script.src, window.location.href);
        // Use the same directory as the script and point to our CSS filename
        const basePath = url.pathname.replace(/[^/]+$/, '');
        const file = (url.pathname.split('/').pop() || '').toLowerCase();
        const cssFile = /main\.js($|\?)/.test(file) ? 'main.css' : 'atunwa-player.css';
        cssHref = url.origin + basePath + cssFile;
        break;
    } catch  {
    // ignore and continue
    }
    // Only inject if we could determine a CSS URL from the script tag.
    if (!cssHref) return;
    const link = document.createElement('link');
    link.id = MARKER_ID;
    link.rel = 'stylesheet';
    link.href = cssHref;
    // Allow cross-origin if needed without blocking
    link.crossOrigin = 'anonymous';
    document.head.appendChild(link);
})();






async function $450c79007f4e6d4a$var$mountInto(container, dev) {
    const [reactMod, reactDomClientMod, appMod] = await Promise.all([
        (parcelRequire("gWV8w")),
        (parcelRequire("dFHx4")),
        (parcelRequire("V5CkR"))
    ]);
    const React = reactMod.default ?? reactMod;
    const ReactDOMClient = reactDomClientMod;
    const AtunwaPlayer = appMod.default ?? appMod;
    if (typeof ReactDOMClient.createRoot === 'function') ReactDOMClient.createRoot(container).render(React.createElement(AtunwaPlayer, {
        dev: dev
    }));
    else {
        // Fallback for React < 18
        const ReactDOM = await (parcelRequire("fi5wH"));
        ReactDOM.render(React.createElement(AtunwaPlayer, {
            dev: dev
        }), container);
    }
}
// 1) If a root div with id="atunwa-player" exists, mount immediately (dev/demo pages)
const $450c79007f4e6d4a$var$directRoot = typeof document !== 'undefined' ? document.getElementById('atunwa-player') : null;

if ($450c79007f4e6d4a$var$directRoot) {
    const params = new URLSearchParams(window.location.search);
    const dev = params.has('dev');
    $450c79007f4e6d4a$var$mountInto($450c79007f4e6d4a$var$directRoot, dev);
} else if (typeof customElements !== 'undefined') {
    // 2) Otherwise, define a lightweight web component that lazy‑loads React and the app
    class AtunwaPlayerElement extends HTMLElement {
        _root = null;
        _mounted = false;
        static get observedAttributes() {
            return [
                'dev'
            ];
        }
        connectedCallback() {
            if (this._mounted) return;
            this._mounted = true;
            // Defer heavy import to idle time when possible
            const schedule = (fn)=>window.requestIdleCallback ? window.requestIdleCallback(fn) : setTimeout(fn, 0);
            schedule(()=>{
                const dev = this.hasAttribute('dev');
                $450c79007f4e6d4a$var$mountInto(this, dev);
            });
        }
        disconnectedCallback() {
            // Optionally unmount if needed
            // We'll lazy import react-dom only if mounted
            if (this._mounted) (parcelRequire("dFHx4")).then((ReactDOMClient)=>{}).catch(()=>{});
        }
    }
    if (!customElements.get('atunwa-player')) customElements.define('atunwa-player', AtunwaPlayerElement);
}

})();
//# sourceMappingURL=main.js.map
